import { Pipe, PipeTransform } from '@angular/core';
import { Energietraeger, EnergietraegerItem } from '../../domain/model/energietraeger';

@Pipe({
    name: 'energietraeger',
    standalone: false,
})
export class EnergietraegerPipe implements PipeTransform {

    transform(value?: Energietraeger): string {
        if (!value) {
            return value;
        }
        return EnergietraegerItem.getAll().find(item => item.key === value)?.description || value;
    }
}
